exports.components = {
  "component---src-pages-[code]-tsx": () => import("./../../../src/pages/[code].tsx" /* webpackChunkName: "component---src-pages-[code]-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

